// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'c0617588-ab33-42f7-80c3-b514727a36ed',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '63dcf251-e3f4-4950-a7b4-90adaf768464',
      type: 'Container',
      name: 'slot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c0617588-ab33-42f7-80c3-b514727a36ed'
    },
    {
      id: '13615325-2393-4efb-8d4f-4fda0a9b3e4b',
      type: 'Text',
      name: 'amountText',
      className: '',
      x: 15,
      y: 18,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '+XX',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#46130b',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c0617588-ab33-42f7-80c3-b514727a36ed'
    },
    {
      id: 'ba3b88d6-b3ed-4a84-b4dd-02ea1e1ec672',
      type: 'Sprite',
      name: '',
      className: '',
      x: 23,
      y: -72,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Cross_Red',
      parent: 'c0617588-ab33-42f7-80c3-b514727a36ed'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  handleResize: false
} as const;

export class LoseProgressBaseIcon {
  static raw = raw;
  root!: Container;
  slot!: Container;
  amountText!: Text;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
